import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BizflexFacade, ROUTE } from '@bizflex/data-access';

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    canDeactivate: [
      () => {
        const facade = inject(BizflexFacade);
        facade.reset();
        return true;
      },
    ],
    children: [
      {
        path: '',
        loadComponent: () => import('./generic/generic.component').then(m => m.GenericComponent),
      },
      {
        path: ROUTE.ERROR.BAD_REQUEST,
        loadComponent: () => import('./bad-request/bad-request.component').then(m => m.BadRequestComponent),
      },
      {
        path: ROUTE.ERROR.FORBIDDEN,
        loadComponent: () => import('./forbidden/forbidden.component').then(m => m.ForbiddenComponent),
      },
      {
        path: ROUTE.ERROR.NOT_FOUND,
        loadComponent: () => import('./not-found/not-found.component').then(m => m.NotFoundComponent),
      },
      {
        path: ROUTE.ERROR.NOT_ALLOWED,
        loadComponent: () => import('./not-allowed/not-allowed.component').then(m => m.NotAllowedComponent),
      },
      {
        path: ROUTE.ERROR.NOT_ACCEPTABLE,
        loadComponent: () => import('./not-acceptable/not-acceptable.component').then(m => m.NotAcceptableComponent),
      },
      {
        path: ROUTE.ERROR.OFFER_EXPIRED,
        loadComponent: () => import('./offer-expired/offer-expired.component').then(m => m.OfferExpiredComponent),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ErrorPageModule {}
